import * as React from "react"

function VisaIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 82 51"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <rect
                x={0.513}
                y={0.642}
                width={80.425}
                height={49.319}
                rx={5.5}
                fill="#fff"
            />
            <path
                d="M39.923 22.424c-.025 2.223 1.735 3.463 3.061 4.2 1.362.757 1.82 1.242 1.814 1.919-.01 1.035-1.086 1.492-2.093 1.51-1.758.031-2.78-.542-3.592-.975l-.633 3.381c.815.43 2.324.803 3.89.82 3.673 0 6.076-2.07 6.09-5.28.014-4.072-4.937-4.297-4.903-6.118.012-.552.474-1.14 1.485-1.29.5-.076 1.882-.134 3.448.69l.615-3.272c-.842-.35-1.925-.685-3.273-.685-3.458 0-5.89 2.098-5.91 5.1zm15.09-4.819c-.67 0-1.236.447-1.488 1.132l-5.248 14.301h3.671l.73-2.304h4.486l.424 2.304h3.236L58 17.605h-2.987zm.514 4.17l1.06 5.795h-2.902l1.842-5.796zm-20.055-4.17l-2.894 15.433h3.498l2.893-15.433h-3.497zm-5.175 0L26.656 28.11l-1.473-8.932c-.173-.997-.855-1.573-1.613-1.573h-5.952l-.083.448c1.221.303 2.61.791 3.45 1.313.516.32.662.598.832 1.357l2.79 12.315h3.696l5.667-15.433h-3.673"
                fill="url(#prefix__paint0_linear_1396:8)"
            />
            <rect
                x={0.513}
                y={0.642}
                width={80.425}
                height={49.319}
                rx={5.5}
                stroke="#CECECE"
            />
            <defs>
                <linearGradient
                    id="prefix__paint0_linear_1396:8"
                    x1={37.436}
                    y1={33.598}
                    x2={37.963}
                    y2={17.217}
                    gradientUnits="userSpaceOnUse">
                    <stop stopColor="#222357" />
                    <stop offset={1} stopColor="#254AA5" />
                </linearGradient>
            </defs>
        </svg>
    )
}

export default VisaIcon
